export const state = {
  statusesOptions: [
    {
      'id': 1,
      'name': 'Pass',
      'applied_both': false,
      'assignable': 1
    },
    {
      'id': 2,
      'name': 'Refer',
      'applied_both': false,
      'assignable': 1
    },
    {
      'id': 3,
      'name': 'Transferido',
      'applied_both': true,
      'assignable': 1
    },
    {
      'id': 4,
      'name': 'Faltou',
      'applied_both': true,
      'assignable': 1
    },
    {
      'id': 5,
      'name': 'Faleceu',
      'applied_both': true,
      'assignable': 0
    }
  ],
  examTypesOptions: [
    {
      'id': 1,
      'name': 'O.E.A.1'
    },
    {
      'id': 2,
      'name': 'O.E.A.2'
    },
    {
      'id': 3,
      'name': 'P.E.A.A.'
    },
    {
      'id': 4,
      'name': 'Consulta'
    },
    {
      'id': 5,
      'name': 'P.E.A.T.C.'
    }
  ],
  riskFactorsOptions: [
    {
      'id': 1,
      'name': 'SF',
      'description': 'História familiar de deficiência auditiva congénita'
    },
    {
      'id': 2,
      'name': 'IC',
      'description': 'Infeção congénita (sífilis, toxoplasmose, rubéola, citomegalovírus e herpes)'
    },
    {
      'id': 3,
      'name': 'AC',
      'description': 'Anomalias craniofaciais (malformações de pavilhão auricular, meato acústico externo, ausência de filtrum nasal, implantação baixa da raiz do cabelo)'
    },
    {
      'id': 4,
      'name': 'BP',
      'description': 'Peso ao nascimento inferior a 1500g – hiperbilirrubinémia (níveis séricos indicativos de exsanguineo-transfusão)'
    },
    {
      'id': 5,
      'name': 'MO',
      'description': 'Medicação ototóxica por mais de 5 dias (aminoglicosídeos ou outros, associados ou não aos diuréticos de ansa)'
    },
    {
      'id': 6,
      'name': 'MB',
      'description': 'Meningite bacteriana'
    },
    {
      'id': 7,
      'name': 'AP',
      'description': 'Índice de Apgar de 0-4 no 1º minuto ou 0-6 no 5º minuto'
    },
    {
      'id': 8,
      'name': 'VM',
      'description': 'Ventilação mecânica por período igual ou superior a 5 dias'
    },
    {
      'id': 9,
      'name': 'SA',
      'description': 'Sinais ou síndromes associadas à deficiência auditiva de condução ou neurossensorial'
    },
    {
      'id': 10,
      'name': 'HI-HE',
      'description': 'HIV/Hepatite'
    },
    {
      'id': 11,
      'name': 'COVID-19',
      'description': null
    }
  ]
}
